import React from 'react';
import { Avatar, Box, Card, CardHeader, Chip, IconButton, Tooltip, Typography } from '@mui/material';
import { EditOutlined, Settings, TableChart } from '@mui/icons-material';
import * as UIAction from '../../redux/actions/ui.actions';
import DataTable from '../../assets/data-table.svg';
import DataTableActive from '../../assets/data-table-active.svg';
const StreamCard = (props) => {
  const { style, primaryKeys, stream, onSelect, isSelected, fieldMap, isFlowV2 } = props;

  const handleSelectStream = (e) => {
    e.stopPropagation();
    UIAction.selectStream(stream, isFlowV2, primaryKeys);
  };
  return (
    <div style={style}>
      <Card
        onClick={() => onSelect(stream)}
        elevation={0}
        sx={{
          cursor: 'pointer',
          maxWidth: '533px',
          borderTop: '1px solid transparent',
          borderLeft: '1px solid transparent',
          borderRight: '1px solid transparent',
          alignItems: 'center',
          borderBottom: ({ palette }) => `1px solid ${palette.common.divider}`,
          border: ({ palette }) => isSelected && `1px solid ${palette.primary.main}`,
          '& .hotglue-w-MuiCardHeader-action': {
            alignSelf: 'center',
          },
          '& .hotglue-w-MuiCardHeader-content': {
            maxWidth: 'calc(100% - 96px)',
          }
        }}
      >
        <CardHeader
          sx={{
            '.hotglue-w-MuiCardHeader-content p': {
              width: '100%',
              textOverflow: 'ellipsis',
              overflow: 'hidden',
              whiteSpace: 'nowrap',
            }
          }}
          avatar={
            <Avatar
              role='img'
              imgProps={{
                role: 'img',
                alt: 'data-table',
              }}
              aria-label="recipe"
              src={isSelected ? DataTableActive : DataTable}
              sx={{
                border: ({ palette }) =>
                  isSelected ? `1px solid ${palette.primary.main}` : `1px solid ${palette.common.outline}`,
                width: '48px',
                height: '48px',
                '& img': {
                  width: '14px',
                  height: '14px',
                },
              }}
            />
          }
          action={
            <IconButton aria-label={`edit field map for ${stream}` } role='button' color="default" onClick={handleSelectStream} size="medium">
              <EditOutlined />
            </IconButton>
          }
          // TODO: Figure out dynamic truncation based on screen size.
          title={
            // only open the tooltip if the stream length is greater than 35
            <Tooltip title={stream.length > 35 ? stream : ''}>
              <Typography
                variant="body2"
                fontWeight={isSelected ? 500 : 300}
              >
                {stream}
              </Typography>
            </Tooltip>
          }
          subheader={
            <Box width={'100%'} display="flex" gap={0.5} alignItems="baseline">
              {fieldMap[stream]?.isUpdated && (
                <Chip
                  label="updated"
                  color="success"
                  sx={{
                    height: '16px',
                    fontSize: '12px',
                    color: 'common.white'
                  }}
                  size="small"
                />
              )}
              {isSelected && (
                <Typography variant="body2" color="text.lightish">
                  {fieldMap[stream].selected[0] === '*' ? 'All' : fieldMap[stream].selected.length} fields selected
                </Typography>
              )}
            </Box>
          }
        />
      </Card>
    </div>
  );
};

export default StreamCard;
